module.exports = __webpack_public_path__ + "static/media/Cage Product Catalogue.c920949b.pdf";